import React, { useEffect, useState } from "react"
import { Box, Button, TextField, Typography, useTheme } from "@mui/material"
import Header from "components/Header"
import { DataGrid } from "@mui/x-data-grid"
import store from "state/store"
import encrypt from "lib/encryption"
import axios from "axios"
import utill from "lib/utill"
import { config } from "config"
import { useLocation } from "react-router-dom"
import * as XLSX from "xlsx"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

const Commutes = () => {
  const theme = useTheme()

  const routeLocation = useLocation() // 'location'의 이름을 'routeLocation'으로 변경
  const i_name = routeLocation.state?.name // 전달된 상태

  const [name, setName] = React.useState(i_name ?? "")
  const [userName, setUserName] = React.useState("")
  const [startDate, setStartDate] = useState(() => {
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const startOfMonth = new Date(
      Date.UTC(currentYear, currentMonth, 1, 0, 0, 0)
    )
    startOfMonth.setUTCHours(startOfMonth.getUTCHours() + 9) // UTC+9 (한국 시간)
    return startOfMonth.toISOString()
  })

  const [endDate, setEndDate] = useState(() => {
    const today = new Date()
    today.setHours(23, 59, 59, 999) // 종료 시간을 23:59:59로 설정
    today.setUTCHours(today.getUTCHours() + 9)
    return today.toISOString()
  })

  const [rows, setRows] = useState([])
  const [rowCount, setRowCount] = useState(0)
  const [pageSize, setPageSize] = useState(20)
  const [isLoading, setIsLoading] = useState(false)
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  })

  const columns = [
    {
      field: "location_name",
      headerName: "등록지점",
      flex: 0.5,
    },
    {
      field: "user_name",
      headerName: "이름",
      flex: 0.5,
    },
    {
      field: "user_phone_no",
      headerName: "번호",
      flex: 0.5,
    },
    {
      field: "start_time",
      headerName: "출근시간",
      flex: 0.5,
    },
    {
      field: "end_time",
      headerName: "퇴근시간",
      flex: 0.5,
    },
    {
      field: "total_time",
      headerName: "총시간",
      flex: 0.5,
      valueGetter: (params) => {
        if (params.row.start_time == null || params.row.end_time == null)
          return ""
        const startTime = new Date(params.row.start_time)
        const endTime = new Date(params.row.end_time)

        if (!startTime && !endTime) return ""

        // 시간 차이 계산
        const diffMs = endTime - startTime
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
        const diffMinutes = Math.floor(
          (diffMs % (1000 * 60 * 60)) / (1000 * 60)
        )

        return `${diffHours}시간 ${diffMinutes}분`
      },
    },
    {
      field: "status",
      headerName: "상태",
      flex: 0.3,
      // 출근중인지 퇴근인지 상태를 계산하여 표시 및 스타일 적용
      renderCell: (params) => {
        const isWorking = !params.row.end_time // 출근 중인 경우 end_time이 없는 상태
        return (
          <span style={{ color: isWorking ? "orange" : "black" }}>
            {isWorking ? "출근중" : "퇴근"}
          </span>
        )
      },
    },
  ]

  const authKeyEncD = encrypt(
    process.env.REACT_APP_AUTH_KEY,
    process.env.REACT_APP_PUBLIC_KEY
  )

  useEffect(() => {
    getCommuteList()
  }, [paginationModel])

  const getCommuteList = async () => {
    const url = `${config.api}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        page_no: paginationModel.page + 1,
        location_name: name,
        name: userName,
        start_date: startDate,
        end_date: endDate,
        host_oid: utill.base64Decode(sessionStorage.getItem("x-a-h-o") ?? ""),
      },
    }

    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "GET_COMMUTE_HISTORY",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/GetAdminDataJSON",
    }
    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <GetAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </GetAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode.textContent
      const resultObject = JSON.parse(resultText)

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode

        if (result === "+OK") {
          console.log("🚀 ~ getCommuteList ~ resultObject:", resultObject)
          setRowCount(resultObject.Total)
          setRows(resultObject.Item)
        } else {
          console.log("에러1")
        }
      } else {
        console.log("에러1")
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getCommuteListExcel = async () => {
    const url = `${config.api}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        location_name: name,
        name: userName,
        start_date: startDate,
        end_date: endDate,
        host_oid: utill.base64Decode(sessionStorage.getItem("x-a-h-o") ?? ""),
      },
    }

    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "GET_COMMUTE_HISTORY_EXCEL",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/GetAdminDataJSON",
    }
    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <GetAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </GetAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode.textContent
      const resultObject = JSON.parse(resultText)

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode

        if (result === "+OK") {
          // 데이터 가져오기
          const commuteData = resultObject.Item

          // 원하는 컬럼 순서 정의
          const columnsOrder = [
            { key: "location_name", header: "지점이름" },
            { key: "user_name", header: "이름" },
            { key: "start_time", header: "출근시간" },
            { key: "end_time", header: "퇴근시간" },
          ]

          // 컬럼 순서에 맞게 데이터 정렬
          const orderedData = commuteData.map((item) => {
            const orderedItem = {}
            columnsOrder.forEach((column) => {
              orderedItem[column.header] = item[column.key]
            })
            return orderedItem
          })

          // JSON 데이터를 워크시트로 변환
          const ws = XLSX.utils.json_to_sheet(orderedData)
          const wb = XLSX.utils.book_new() // 새로운 워크북 생성
          XLSX.utils.book_append_sheet(wb, ws, "Commute Records") // 워크북에 시트 추가

          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          }) // 워크북을 배열로 변환
          const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
          }) // Blob 객체 생성

          // 엑셀 파일 다운로드
          saveAs(
            blob,
            `${utill.base64Decode(
              sessionStorage.getItem("x-a-h-t")
            )}_근태관리_(${formatDate(startDate)}~${formatDate(endDate)}).xlsx`
          )
        } else {
          console.log("에러1")
        }
      } else {
        console.log("에러1")
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error)
      setIsLoading(false)
    }
  }

  const getCommuteListExcel_V2 = async () => {
    const url = `${config.api}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        location_name: name,
        name: userName,
        start_date: startDate,
        end_date: endDate,
        host_oid: utill.base64Decode(sessionStorage.getItem("x-a-h-o") ?? ""),
      },
    }

    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "GET_COMMUTE_HISTORY_EXCEL",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/GetAdminDataJSON",
    }
    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <GetAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </GetAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode.textContent
      const resultObject = JSON.parse(resultText)

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode

        if (result === "+OK") {
          // 데이터 가져오기
          const commuteData = resultObject.Item

          // 데이터 가공 및 엑셀 내보내기 호출
          exportToExcel(commuteData, startDate, endDate)
        } else {
          console.log("에러1")
        }
      } else {
        console.log("에러1")
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error)
      setIsLoading(false)
    }
  }

  const handlePaginationModelChange = (newPaginationModel) => {
    console.log(newPaginationModel)
    setPaginationModel(newPaginationModel)
  }

  const handleNameChange = (event) => {
    setName(event.target.value)
  }

  const handleUserNameChange = (event) => {
    setUserName(event.target.value)
  }

  const handleButtonClick = (params) => {
    getCommuteList()
  }

  const handleButtonClickExcel = (params) => {
    getCommuteListExcel()
  }
  const handleButtonClickExcel_V2 = (params) => {
    getCommuteListExcel_V2()
  }

  const handleStartDateChange = (event) => {
    //setStartDate(event.target.value + " 00:00:00")
    const selectedDate = new Date(event.target.value)
    selectedDate.setHours(0, 0, 0, 0) // 선택한 날짜의 시간을 00:00:00으로 설정
    selectedDate.setUTCHours(selectedDate.getUTCHours() + 9) // UTC+9 (한국 시간)
    setStartDate(selectedDate.toISOString())
  }

  const handleEndDateChange = (event) => {
    //setEndDate(event.target.value + " 23:59:59")
    const selectedDate = new Date(event.target.value)
    selectedDate.setHours(23, 59, 59, 999) // 선택한 날짜의 시간을 23:59:59로 설정
    selectedDate.setUTCHours(selectedDate.getUTCHours() + 9) // UTC+9 (한국 시간)
    setEndDate(selectedDate.toISOString())
  }

  // 엑셀 변환 및 다운로드 함수
  async function exportToExcel(commuteData, startDate, endDate) {
    // 날짜 범위 내 모든 날짜 목록 생성 함수
    const generateDateRange = (start, end) => {
      const dates = []
      let currentDate = new Date(start)
      end = new Date(end)

      while (currentDate <= end) {
        dates.push(
          `${currentDate.getMonth() + 1}.${String(
            currentDate.getDate()
          ).padStart(2, "0")}`
        )
        currentDate.setDate(currentDate.getDate() + 1)
      }

      return dates
    }

    // 날짜 범위 내 컬럼 키 생성
    const dateColumns = generateDateRange(startDate, endDate).flatMap(
      (date) => [
        `${date}s`,
        `${date}m`,
        `${date}e`,
        `${date} 총시간`,
        `${date} 공백`,
      ]
    )

    // 데이터 가공: 이름 + 지점 별로 그룹화
    const processedData = {}

    commuteData.forEach((item) => {
      const dateKey = item.start_time
        ? item.start_time.split(" ")[0].replace(/^\d{4}\./, "") // 연도 부분 제거
        : null
      if (!dateKey) return

      const groupKey = `${item.user_name}-${item.location_name}`

      if (!processedData[groupKey]) {
        processedData[groupKey] = {
          role: item.role || "없음", // role이 없을 경우 "없음"으로 표시
          dates: {},
        }
      }

      if (!processedData[groupKey].dates[dateKey]) {
        processedData[groupKey].dates[dateKey] = {
          start_time: null,
          middle_time: null,
          end_time: null,
        }
      }

      // start_time은 가장 오래된 시간, end_time은 가장 최신 시간으로 설정
      const itemStartTime = new Date(item.start_time)
      const itemMiddleTime = item.middle_time
        ? new Date(item.middle_time)
        : null
      const itemEndTime = item.end_time ? new Date(item.end_time) : null

      if (
        !processedData[groupKey].dates[dateKey].start_time ||
        itemStartTime <
          new Date(processedData[groupKey].dates[dateKey].start_time)
      ) {
        processedData[groupKey].dates[dateKey].start_time = item.start_time
      }

      if (
        itemMiddleTime &&
        (!processedData[groupKey].dates[dateKey].middle_time ||
          itemMiddleTime <
            new Date(processedData[groupKey].dates[dateKey].middle_time))
      ) {
        processedData[groupKey].dates[dateKey].middle_time = item.middle_time
      }

      if (
        itemEndTime &&
        (!processedData[groupKey].dates[dateKey].end_time ||
          itemEndTime >
            new Date(processedData[groupKey].dates[dateKey].end_time))
      ) {
        processedData[groupKey].dates[dateKey].end_time = item.end_time
      }
    })

    // ExcelJS 형식에 맞게 데이터 구성
    const excelData = Object.keys(processedData).map((groupKey) => {
      const [userName, locationName] = groupKey.split("-")
      const role = processedData[groupKey].role
      const rowData = {
        지점이름: locationName,
        직무: role, // 직무 정보를 추가합니다.
        이름: userName,
      }

      dateColumns.forEach((column) => {
        const [date, type] = column.split(/(s|m|e| 총시간)/)
        const attendance = processedData[groupKey].dates[date] || {}

        if (role === "주방" || role === "홀") {
          // 직무가 주방 또는 홀일 경우, 시간이 아닌 O 또는 X 표시
          if (type === "s") {
            rowData[column] = attendance.start_time ? "O" : "X"
          } else if (type === "m") {
            rowData[column] = attendance.middle_time ? "O" : "X"
          } else if (type === "e") {
            rowData[column] = attendance.end_time ? "O" : "X"
          }
        } else {
          // 그 외 직무는 시간 표시
          if (type === "s") {
            rowData[column] = attendance.start_time
              ? attendance.start_time.split(" ")[1].slice(0, 5)
              : "X"
          } else if (type === "m") {
            rowData[column] = attendance.middle_time
              ? attendance.middle_time.split(" ")[1].slice(0, 5)
              : "X"
          } else if (type === "e") {
            rowData[column] = attendance.end_time
              ? attendance.end_time.split(" ")[1].slice(0, 5)
              : "X"
          }
        }

        if (type === " 총시간") {
          if (attendance.start_time && attendance.end_time) {
            const start = new Date(attendance.start_time)
            const end = new Date(attendance.end_time)
            const workTimeMinutes = Math.floor((end - start) / (1000 * 60))
            rowData[column] = `${Math.floor(workTimeMinutes / 60)}시간 ${
              workTimeMinutes % 60
            }분`
          } else {
            rowData[column] = "-" // 총시간이 없을 경우 "-"
          }
        } else if (type === " 공백") {
          rowData[column] = "" // 공백 열
        }
      })

      return rowData
    })

    // ExcelJS 워크북 생성 및 시트 추가
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet("Commute Records")

    // 제목 행 설정 - 기본 컬럼 + 날짜별 동적 컬럼
    worksheet.columns = [
      { header: "지점이름", key: "지점이름" },
      { header: "직무", key: "직무" },
      { header: "이름", key: "이름" },
      ...dateColumns.map((key) => ({
        header: key.includes(" 총시간")
          ? "총시간"
          : key.includes(" 공백")
          ? ""
          : key,
        key,
      })),
    ]

    // 데이터 행 추가
    excelData.forEach((data) => worksheet.addRow(data))

    // 엑셀 파일 버퍼 생성 및 다운로드
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: "application/octet-stream" })
    saveAs(
      blob,
      `${utill.base64Decode(
        sessionStorage.getItem("x-a-h-t")
      )}_근태관리_(${startDate}~${endDate}).xlsx`
    )
  }

  // 날짜 부분만 추출하는 함수
  function formatDate(date) {
    return date.split("T")[0] // "T"를 기준으로 날짜 부분만 남김
  }

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="출퇴근" subtitle="출퇴근 리스트" />
      <Box
        height="75vh"
        width="99%"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="1rem"
        >
          <Box>
            <Typography
              component="p"
              variant="body1"
              sx={{ paddingRight: "1rem" }}
            ></Typography>
          </Box>
          <Box display="flex" alignItems="center" gap="1rem">
            <TextField
              label="시작 날짜"
              type="date"
              value={startDate.split("T")[0]}
              onChange={handleStartDateChange}
              sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }}
            />
            <TextField
              label="끝 날짜"
              type="date"
              value={endDate.split("T")[0]}
              onChange={handleEndDateChange}
              sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }}
            />
            <TextField
              label="지점 이름으로 검색"
              value={name}
              onChange={handleNameChange}
              sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }}
            />
            <TextField
              label="사람 이름으로 검색"
              value={userName}
              onChange={handleUserNameChange}
              sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }}
            />
            <Button
              variant="contained"
              onClick={handleButtonClick}
              sx={{ mb: 1 }}
            >
              검색
            </Button>
            <Button
              variant="contained"
              onClick={handleButtonClickExcel}
              sx={{ mb: 1 }}
            >
              엑셀다운로드
            </Button>
            <Button
              variant="contained"
              onClick={handleButtonClickExcel_V2}
              sx={{ mb: 1 }}
            >
              엑셀다운로드2
            </Button>
          </Box>
        </Box>
        <DataGrid
          getRowId={(row) => row.commute_records_oid}
          rows={rows || []}
          columns={columns}
          pageSizeOptions={[pageSize]}
          rowCount={rowCount}
          paginationMode="server"
          onPaginationModelChange={handlePaginationModelChange}
          paginationModel={paginationModel}
          loading={isLoading}
        />
      </Box>
    </Box>
  )
}

export default Commutes
